export default __webpack_public_path__ + "static/media/white.8b6afb73.png";